import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'appOperatorChatMessageFormat'
})

@Injectable()
export class OperatorChatMessageFormatPipe implements PipeTransform {
  private pushedMessageTemplate;

  constructor(private _translateService: TranslateService) {
    this.pushedMessageTemplate = '[Pushed: $1]';
    this._translateService.get('bcChatMessages.pushed').toPromise()
      .then(translation => this.pushedMessageTemplate = `[${translation}: $1]`);
  }

  transform(message) {
    return message.replace(/(?:<|&lt;)push(?:>|&gt;)(.*)(?:<|&lt;)\/push(?:>|&gt;)/g, this.pushedMessageTemplate);
  }
}
